import { CategorySlug } from "./categories";

export type Revendeur = {
  name: string;
  prix: number;
  url: string;
};

export type Product = {
  slug: string;
  sku: string;
  name: string;
  categorySlug: CategorySlug;
  short: string;
  description: string;
  specs: Record<string, string>;
  images: Array<string>;
  revendeurs: Revendeur[];
  ficheTechnique?: string;
  discontinued?: boolean;
  successorSlug?: string;
};

export const products: Product[] = [
  {
    slug: "armoire-fusils-7-armes",
    sku: "Tresorsafe7",
    name: "Armoire à fusils — 7 armes",
    categorySlug: "armoires-a-fusils",
    short:
      "Armoire sécurisée 7 armes (6 fusils + 1 strap porte), serrure à clés, coffre-fort interne intégré.",
    description:
      "Succède à notre TS6 avec un strap supplémentaire sur la porte permettant de ranger une arme longue de plus. Corps et porte acier 2mm, verrouillage 6 pênes anti-sciage, coffre-fort interne pour munitions et documents.",
    specs: {
      Capacité: "7 armes (6 fusils + 1 strap porte)",
      "Dimensions extérieures (HxLxP)": "1490 x 350 x 280 mm",
      "Dimensions intérieures (HxLxP)": "1310 x 345 x 230 mm",
      "Dimensions coffre intérieur (HxLxP)": "165 x 345 x 165 mm",
      Volume: "104 litres",
      Poids: "45 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "2 ans constructeur",
      Pênes:
        "6 pênes acier circulaire anti-sciage (4 horizontaux + 2 verticaux)",
      Finition:
        "Peinture époxy noire chauffée au four pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps et porte en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation": "4 trous en fond + 4 au sol, kit de fixation fourni",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      "Hauteur maximale arme":
        "1310 mm à l'intérieur, 1480 mm sur la porte (avec strap)",
      Accessoires:
        "2 ammo boxes amovibles, strap haut et sac bas pour 1 arme longue supplémentaire (étagères à retirer), double de clés possible sur numéro de série (1 paire max)",
    },
    images: [
      "/TS7/TS7 en condition.png",
      "/TS7/TS7 ouvert.png",
      "/TS7/armoire-a-fusils-tresorsafe-7-armes-serrure-a-cles-coffre-interieur.webp",
      "/TS7/armoire-a-fusils-tresorsafe-7-armes-serrure-a-cles-bas (1).webp",
      "/TS7/TS7 USPs.png",
      "/TS7/TS7 dimensions dimensions extérieures.png",
      "/TS7/TS7 dimensions intérieures.png",
      "/TS7/TS7 dimensions coffre intérieure.png",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 240.87,
        url: "https://1001coffres.com/armoire-1-9-fusils/8318-armoire-a-fusils-tresorsafe-7-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS7/fiche technique 7 fusils TresorSafe.pdf",
  },
  {
    slug: "armoire-fusils-10-armes-serrure-a-cles",
    sku: "Tresorsafe10",
    name: "Armoire à fusils — 10 armes (serrure à clés)",
    categorySlug: "armoires-a-fusils",
    short:
      "Armoire sécurisée 10 armes (8 fusils + 2 straps porte), serrure à clés, 3 coffrets amovibles.",
    description:
      "Succède à notre TS8 avec deux straps supplémentaires sur la porte pour ranger deux armes longues de plus. Corps et porte acier 2mm, verrouillage 6 pênes anti-sciage, coffre-fort interne pour munitions et documents.",
    specs: {
      Capacité: "10 armes (8 fusils + 2 straps porte)",
      "Dimensions extérieures (HxLxP)": "1490 x 450 x 280 mm",
      "Dimensions intérieures (HxLxP)": "1310 x 445 x 230 mm",
      "Dimensions coffre intérieur (HxLxP)": "165 x 445 x 165 mm",
      Volume: "134 litres",
      Poids: "55 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "2 ans constructeur",
      Pênes:
        "6 pênes acier circulaire anti-sciage (4 horizontaux + 2 verticaux)",
      Finition:
        "Peinture époxy noire chauffée au four pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps et porte en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation": "4 trous en fond + 4 au sol, kit de fixation fourni",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      "Hauteur maximale arme":
        "1310 mm à l'intérieur, 1460 mm sur la porte (avec straps)",
      Accessoires:
        "3 ammo boxes amovibles (haute/milieu/basse), straps haut et sacs bas pour 2 armes longues supplémentaires (étagères à retirer), double de clés possible sur numéro de série (1 paire max)",
    },
    images: [
      "/TS10/TS10 porte ouverte.png",
      "/TS10/TS10 dans le salon.png",
      "/TS10/TS10 porte.png",
      "/TS10/TS10 straps bas.png",
      "/TS10/TS10 straps hauts.png",
      "/TS10/TS10 coffre intérieur.webp",
      "/TS10/TS10 USP.png",
      "/TS10/TS10 dimensions extérieures.png",
      "/TS10/TS10 dimensions intérieures.png",
      "/TS10/TS10 dimensions coffre intérieur.png",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 271.56,
        url: "https://1001coffres.com/armoire-1-9-fusils/8316-armoire-a-fusils-tresorsafe-10-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS10/fiche technique 10 fusils TresorSafe.pdf",
  },
  {
    slug: "armoire-fusils-10-armes-serrure-electronique",
    sku: "Tresorsafe10E",
    name: "Armoire à fusils — 10 armes (serrure électronique)",
    categorySlug: "armoires-a-fusils",
    short:
      "Armoire sécurisée 10 armes (8 fusils + 2 straps porte), serrure à codes avec clés de secours.",
    description:
      "Même capacité que le TS10 avec une serrure électronique à code programmable et clés de secours incluses pour un accès rapide. Corps et porte acier 2mm, verrouillage 6 pênes anti-sciage, coffre-fort interne pour munitions et documents.",
    specs: {
      Capacité: "10 armes (8 fusils + 2 straps porte)",
      "Dimensions extérieures (HxLxP)": "1450 x 450 x 320 mm",
      "Dimensions intérieures (HxLxP)": "1270 x 445 x 270 mm",
      "Dimensions coffre intérieur (HxLxP)": "165 x 345 x 165 mm",
      Volume: "152,5 litres",
      Poids: "55 kg",
      Serrure:
        "à codes programmable, avec serrure de secours (fournie avec 2 clés de secours)",
      Garantie: "2 ans constructeur",
      Pênes:
        "6 pênes acier circulaire anti-sciage (4 horizontaux + 2 verticaux)",
      Finition:
        "Peinture époxy noire chauffée au four pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps et porte en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation": "4 trous en fond + 4 au sol, kit de fixation fourni",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      "Hauteur maximale arme":
        "1270 mm à l'intérieur, 1440 mm sur la porte (avec straps)",
      Accessoires:
        "3 ammo boxes amovibles (haute/milieu/basse), straps haut et sacs bas pour 2 armes longues supplémentaires (étagères à retirer)",
    },
    images: [
      "/TS10E/TS10E en situation.png",
      "/TS10E/TS10E en situation ouvert.png",
      "/TS10E/TS10E porte.png",
      "/TS10E/TS10E serrure électronique.png",
      "/TS10E/TS10E garage.png",
      "/TS10E/TS10E straps hauts.png",
      "/TS10E/TS10E straps bas.png",
      "/TS10E/TS10E USP.png",
      "/TS10E/TS10E dimensions extérieures.png",
      "/TS10E/TS10E dimensions intérieures.png",
      "/TS10E/TS10E dimensions coffre intérieur.png",
      "/TS10E/armoire-a-fusils-tresorsafe-10E-armes-serrure-a-cles-coffre-interieur.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 336,
        url: "https://1001coffres.com/armoire-1-9-fusils/8319-armoire-a-fusils-tresorsafe-10-armes-serrure-electronique-avec-cles-de-secours.html",
      },
    ],
    ficheTechnique: "/TS10E/fiche technique 10E fusils TresorSafe.pdf",
  },
  {
    slug: "armoire-fusils-15-armes",
    sku: "Tresorsafe15",
    name: "Armoire à fusils — 15 armes",
    categorySlug: "armoires-a-fusils",
    short:
      "Armoire sécurisée 15 armes (12 fusils + 3 straps porte), serrure à clés, 5 tablettes modulables.",
    description:
      "Succède à notre TS12 avec trois straps supplémentaires sur la porte pour ranger trois armes longues de plus. Compartiment latéral à 5 tablettes modulables, corps et porte acier 2mm, coffre-fort interne pour munitions et documents.",
    specs: {
      Capacité: "15 armes (12 fusils + 3 straps porte)",
      "Dimensions extérieures (HxLxP)": "1490 x 700 x 330 mm",
      "Dimensions intérieures (HxLxP)":
        "1480 x 695 x 280 mm au total (1310 x 460 x 280 mm côté rangement armes, 1480 x 235 x 280 mm côté tablettes)",
      "Dimensions coffre intérieur (HxLxP)": "165 x 445 x 205 mm",
      Volume: "225 litres",
      Poids: "80 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "2 ans constructeur",
      Pênes:
        "6 pênes acier circulaire anti-sciage (4 horizontaux + 2 verticaux)",
      Finition:
        "Peinture époxy noire chauffée au four pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps et porte en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation": "4 trous en fond + 4 au sol, kit de fixation fourni",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      "Hauteur maximale arme":
        "1310 mm à l'intérieur, 1480 mm sur la porte (avec straps)",
      Accessoires:
        "5 tablettes modulables et enlevables (côté droit), 3 ammo boxes amovibles sur porte, straps haut et sacs bas pour 3 armes longues supplémentaires (ammo boxes à retirer), double de clés possible sur numéro de série (1 paire max)",
    },
    images: [
      "/TS15/TS15 en condition.png",
      "/TS15/TS15 ouvert.png",
      "/TS15/TS15 ouverte sans tablettes latérales.png",
      "/TS15/supports étagères TS15.webp",
      "/TS15/supports étagères TS15 (2).webp",
      "/TS15/TS15 USPs.png",
      "/TS15/TS15 dimensions extérieures.png",
      "/TS15/TS15 dimensions intérieures.png",
      "/TS15/TS15 dimensions coffre intérieur.png",
      "/TS15/armoire-a-fusils-tresorsafe-15-armes-serrure-a-cles-ouverte.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 418.8,
        url: "https://1001coffres.com/armoire-10-fusils/8315-armoire-a-fusils-tresorsafe-15-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS15/fiche technique 15 fusils TresorSafe.pdf",
  },
  {
    slug: "armoire-fusils-6-armes",
    sku: "Tresorsafe6",
    name: "Armoire à fusils — 6 armes",
    categorySlug: "armoires-a-fusils",
    short: "Armoire sécurisée pour 6 armes, ancrage renforcé, serrure à clés.",
    description:
      "Construction acier, parois renforcées. Conçue pour un stockage sûr de 6 armes longues. Pré-perçages pour ancrage mural et au sol.",
    specs: {
      Capacité: "6 armes",
      "Dimensions extérieures (HxLxP)": "1490 x 350 x 280 mm",
      "Dimensions intérieures (HxLxP)": "1325 x 346 x 220 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 440 x 170 mm",
      Poids: "45 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "1 an",
      Pênes:
        "6 pênes en acier nickelé Hor-Vert de verrouillage (4+1+1) Ø 22 mm",
      Finition:
        "Peinture époxy noire chauffée à 220° pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation":
        "trous de fixation au dos et bas pour fixage au mur et / au sol",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      Accessoires: "offerts : boulons de fixation, tapis de sol",
    },
    images: [
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles face.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-bas.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-coffre-interieur.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-herobanner.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-lateral.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-situation.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-usps.webp",
      "/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-with-riffles.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 241.87,
        url: "https://1001coffres.com/armoire-1-9-fusils/8218-armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS6/fiche technique 6 fusils TresorSafe.pdf",
    discontinued: true,
    successorSlug: "armoire-fusils-7-armes",
  },
  {
    slug: "armoire-fusils-8-armes",
    sku: "Tresorsafe8",
    name: "Armoire à fusils — 8 armes",
    categorySlug: "armoires-a-fusils",
    short:
      "Version 8 fusils avec mousse de protection, compartiments accessoires, range-documents sur la porte et ancrage sur serrure multi-points.",
    description:
      "Idéale pour collections moyennes. Charnières dissimulées et renforts anti-arrachement.",
    specs: {
      Capacité: "8 armes",
      "Dimensions extérieures (HxLxP)": "1490 x 450 x 280 mm",
      "Dimensions intérieures (HxLxP)": "1325 x 446 x 220 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 440 x 170 mm",
      Poids: "55 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "1 an",
      Pênes:
        "6 pênes en acier nickelé Hor-Vert de verrouillage (4+1+1) Ø 22 mm",
      Finition:
        "Peinture époxy noire chauffée à 220° pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation":
        "trous de fixation au dos et bas pour fixage au mur et / au sol",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      Accessoires: "offerts : boulons de fixation, tapis de sol",
    },
    images: [
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-face.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-coffre-interieur.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-ouverte-remplie.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-ouverte.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-situation.webp",
      "/TS8/armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles-USPs.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 272.65,
        url: "https://1001coffres.com/armoire-1-9-fusils/8219-armoire-a-fusils-tresorsafe-8-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS8/fiche technique 8 fusils TresorSafe.pdf",
    discontinued: true,
    successorSlug: "armoire-fusils-10-armes-serrure-a-cles",
  },
  {
    slug: "armoire-fusils-12-armes",
    sku: "Tresorsafe12",
    name: "Armoire à fusils — 12 armes",
    categorySlug: "armoires-a-fusils",
    short:
      "Grande capacité 12 armes, parois multi-couches et points d’ancrage renforcés.",
    description:
      "Pour les besoins exigeants. Séparateurs intérieurs, mousse de protection, coffre intérieur pour munitions, range-documents sur la porte.",
    specs: {
      Capacité: "12 armes",
      "Dimensions extérieures (HxLxP)": "1490 x 700 x 330 mm",
      "Dimensions intérieures (HxLxP)": "1325 x 696 x 250 mm",
      "Dimensions coffre intérieur (HxLxP)": "150 x 240 x 160 mm",
      Poids: "80 kg",
      Serrure: "à clés (fourni avec 2 clés)",
      Garantie: "1 an",
      Pênes:
        "6 pênes en acier nickelé Hor-Vert de verrouillage (4+1+1) Ø 22 mm",
      Finition:
        "Peinture époxy noire chauffée à 220° pour une meilleure résistance",
      "Epaisseur de la paroi":
        "Corps en acier de qualité supérieure, épaisseur 2 mm",
      "Trous de fixation":
        "trous de fixation au dos et bas pour fixage au mur et / au sol",
      "Coffre interne":
        "Coffre-fort interne avec serrure à cylindre, ouverture avec 2 clés",
      Accessoires: "offerts : boulons de fixation, tapis de sol",
    },
    images: [
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-fermée.webp",
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-ouverte-complete.webp",
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-ouverte.webp",
      "/TS12/armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles-USPs.webp",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 423.2,
        url: "https://1001coffres.com/armoire-10-fusils/8220-armoire-a-fusils-tresorsafe-12-armes-serrure-a-cles.html",
      },
    ],
    ficheTechnique: "/TS12/Tresor Safe Tresorsafe12 fusils.pdf",
    discontinued: true,
    successorSlug: "armoire-fusils-15-armes",
  },
  {
    slug: "boite-a-cles-ak-1b",
    sku: "AK-1B",
    name: "Boîte à clés — AK-1B",
    categorySlug: "armoires-a-cles",
    short:
      "Boîte à clés murale sécurisée AK-1B, verrouillage à combinaison 4 chiffres (10 000 combinaisons), pour ranger jusqu'à 4 clés en extérieur.",
    description:
      "Boîte à clés compacte à fixer au mur, avec serrure à combinaison 4 chiffres offrant 10 000 combinaisons programmables pour une sécurité personnalisée. Fabriquée en alliage de zinc haute résistance et acier massif, avec cylindre de serrure en PP pour une protection fiable. Kit de fixation murale inclus pour une installation facile. Idéale pour partager l'accès à un logement (locataires, prestataires, famille) sans multiplier les copies de clés.",
    specs: {
      Capacité: "2 clés double pannetons + 2 clés simples",
      "Dimensions extérieures (HxLxP)": "114 x 94 x 40 mm",
      "Dimensions intérieures (HxLxP)": "90 x 62 x 30 mm",
      Volume: "0,17 litres",
      Poids: "0,27 kg",
      Serrure: "à combinaison 4 chiffres (10 000 combinaisons programmables)",
      Garantie: "2 ans constructeur",
      Matériau:
        "alliage de zinc haute résistance et acier massif, cylindre de serrure en PP",
      Fixation: "murale, kit de fixation fourni",
    },
    images: [
      "/AK-1B/Boite à clés AK-1B fermé.png",
      "/AK-1B/Boite à clés AK-1B ouvert.png",
      "/AK-1B/Boite à clés AK-1B ouvert et fermé.png",
      "/AK-1B/Boite à clés AK-1B fixé sur un mur.png",
      "/AK-1B/Boite à clés AK-1B dos.png",
      "/AK-1B/boite à clés AK-1B ouvert posé.png",
      "/AK-1B/AK-1B USPs.png",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 23,
        url: "https://1001coffres.com/boite-a-clefs/1077-boite-a-cles-keybox-serrure-a-combinaison.html",
      },
    ],
    ficheTechnique: "/AK-1B/AK-1B fiche technique.pdf",
  },
  {
    slug: "coffre-fort-maison-bureau-t17e",
    sku: "T17E",
    name: "Coffre-fort maison & bureau — T17E",
    categorySlug: "coffres-forts",
    short:
      "Coffre-fort compact T17E pour maison et bureau, serrure électronique à code avec 2 clés de secours, conforme au rangement d'armes de catégorie B, C et D.",
    description:
      "Coffre-fort robuste en acier massif (paroi 1,5mm, porte avec plaque acier 3mm), équipé d'un clavier électronique à code programmable de 3 à 8 chiffres et de doubles pênes de verrouillage anti-sciage. 2 clés de secours fournies en cas d'oubli du code ou de piles déchargées. Intérieur revêtu de moquette grise pour protéger vos objets de valeur. Conforme à l'article R.314-3 du Code de la sécurité intérieure pour le stockage d'armes de catégorie B, C et D. Fixation murale ou au sol, kit de fixation fourni.",
    specs: {
      "Dimensions extérieures (HxLxP)": "170 x 230 x 170 mm",
      "Dimensions intérieures (HxLxP)": "165 x 225 x 130 mm",
      Poids: "3 kg",
      Serrure: "électronique à code (3-8 chiffres) + 2 clés de secours",
      Pênes: "doubles pênes dormants circulaires anti-sciage acier renforcés",
      Matériau: "acier massif, paroi 1,5mm / porte avec plaque acier 3mm",
      "Revêtement intérieur": "moquette grise",
      Fixation: "murale ou au sol, kit de fixation fourni",
      Piles: "remplaçables manuellement",
      Garantie: "2 ans constructeur",
      Conformité:
        "Article R.314-3 du Code de la sécurité intérieure (armes catégorie B, C, D)",
      Normes: "ISO 9001, CE, RoHS",
      "Valeur recommandée protégée":
        "1000€ d'argent liquide ou 10000€ d'objets de valeur",
    },
    images: [
      "/T17E/T17E fermé.png",
      "/T17E/T17E ouvert.png",
      "/T17E/T17E porte.png",
      "/T17E/T17E clé de sécurité.png",
      "/T17E/T17E en situation.png",
      "/T17E/T17E USPs.png",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 48,
        url: "https://1001coffres.com/mini-coffre-fort/8320-coffre-fort-tresorsafe-pour-maison-bureau-t17e-serrure-electronique-avec-cles-de-secours-5032548102361.html",
      },
    ],
    ficheTechnique: "/T17E/T17E fiche technique.pdf",
  },
  {
    slug: "coffre-fort-maison-bureau-t50ed",
    sku: "T50ED",
    name: "Coffre-fort maison & bureau — T50ED",
    categorySlug: "coffres-forts",
    short:
      "Coffre-fort T50ED grande capacité pour maison et bureau, serrure électronique à code avec 2 clés de secours, tablette amovible, conforme au rangement d'armes de catégorie B, C et D.",
    description:
      "Coffre-fort grand volume (65,5 litres) en acier massif (corps 2mm, porte avec plaque acier 3mm), équipé d'un clavier électronique à code programmable de 3 à 8 chiffres et de doubles pênes de verrouillage anti-sciage. 2 clés de secours fournies en cas d'oubli du code ou de piles déchargées. Livré avec une tablette de rangement amovible pour organiser l'espace ou obtenir une protection toute hauteur. Intérieur revêtu de moquette grise pour protéger vos objets de valeur. Conforme à l'article R.314-3 du Code de la sécurité intérieure pour le stockage d'armes de catégorie B, C et D. Fixation murale ou au sol, kit de fixation fourni (4 trous prépercés).",
    specs: {
      "Dimensions extérieures (HxLxP)": "500 x 412 x 350 mm",
      "Dimensions intérieures (HxLxP)": "495 x 407 x 310 mm",
      Volume: "65,5 litres",
      Poids: "18 kg",
      Serrure: "électronique à code (3-8 chiffres) + 2 clés de secours",
      Pênes: "doubles pênes dormants circulaires anti-sciage acier renforcés",
      Matériau: "acier massif, corps 2mm / porte avec plaque acier 3mm",
      Tablette: "1 tablette de rangement amovible",
      "Revêtement intérieur": "moquette grise",
      Fixation: "murale ou au sol, kit de fixation fourni (4 trous prépercés)",
      Garantie: "2 ans constructeur",
      Conformité:
        "Article R.314-3 du Code de la sécurité intérieure (armes catégorie B, C, D)",
      Normes: "ISO 9001, CE, RoHS",
      "Valeur recommandée protégée":
        "1000€ d'argent liquide ou 10000€ d'objets de valeur",
    },
    images: [
      "/T50ED/T50ED fermé.png",
      "/T50ED/T50ED fermé autre angle.png",
      "/T50ED/T50ED ouvert.png",
      "/T50ED/T50ED serrure à codes.png",
      "/T50ED/T50ED dos.png",
      "/T50ED/T50ED en situation.png",
      "/T50ED/T50ED USPs.png",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 134.39,
        url: "https://1001coffres.com/coffre-de-securite/8321-coffre-fort-tresorsafe-pour-maison-bureau-t50ed-serrure-electronique-avec-cles-de-secours-5032548102361.html",
      },
    ],
    ficheTechnique: "/T50ED/T50ED fiche technique.pdf",
  },
  {
    slug: "armoire-a-cles-e48k",
    sku: "E48K",
    name: "Armoire à clés 48 clés — E48K",
    categorySlug: "armoires-a-cles",
    short:
      "Armoire à clés murale 48 crochets, serrure électronique à code avec 2 clés de secours, fente de dépôt sécurisée pour déposer des clés sans ouvrir la porte.",
    description:
      "Armoire à clés professionnelle offrant 48 crochets de rangement (40 à l'intérieur, 8 sur la porte) avec étiquettes fournies pour identifier chaque jeu de clés. Une fente de dépôt sur le côté gauche permet de déposer des clés sans ouvrir la porte, et un déflecteur anti-pêche empêche tout retrait non autorisé depuis l'extérieur. Verrouillage par serrure électronique à code, avec 2 clés de secours fournies en cas d'oubli du code ou de piles déchargées. Structure en acier massif (corps 1,5mm, porte 3mm), intérieur revêtu de moquette grise pour protéger les clés. Livrée avec kit de fixation murale (chevilles + vis).",
    specs: {
      Capacité: "48 crochets (40 dans le coffre + 8 sur la porte)",
      "Dimensions extérieures (HxLxP)": "360 x 300 x 100 mm",
      "Dimensions intérieures (HxLxP)": "350 x 275 x 80 mm",
      Poids: "7,5 kg",
      Serrure: "électronique à code + 2 clés de secours",
      Pênes: "2 pênes dormants circulaires anti-sciage acier renforcés (horizontaux)",
      Matériau: "acier massif, corps 1,5mm / porte 3mm",
      "Revêtement intérieur": "moquette grise",
      Sécurité: "fente de dépôt sur le côté gauche, déflecteur anti-pêche",
      Accessoires: "48 étiquettes de clés, porte-clés de couleurs différentes fournis",
      Fixation: "murale, chevilles + vis fournies",
      Finition: "peinture haute qualité anti-rayures",
      Garantie: "2 ans constructeur",
    },
    images: [
      "/E48K/E48K fermé.png",
      "/E48K/E48K ouvert.png",
      "/E48K/E48K porte.png",
      "/E48K/E48K accessoires.png",
      "/E48K/E48K dos.png",
      "/E48K/E48K en situation.png",
      "/E48K/E48K USPs.png",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 101.99,
        url: "https://1001coffres.com/coffre-fort-pour-cle/8322-coffre-a-cles-tresorsafe-e48k-avec-fente-de-depot-serrure-electronique-avec-cles-de-secours-5032548101807.html",
      },
    ],
    ficheTechnique: "/E48K/E48K fiche technique.pdf",
  },
  {
    slug: "deshumidificateur-reutilisable",
    sku: "TSDSH",
    name: "Déshumidificateur réutilisable pour coffres-forts et armoires",
    categorySlug: "armoires-a-fusils",
    short:
      "Sachet déshumidifiant réutilisable à placer dans un coffre-fort ou une armoire à fusils, pour limiter l'humidité, la rouille et les mauvaises odeurs, sans alimentation électrique.",
    description:
      "Ce déshumidificateur réutilisable protège armes, documents et objets de valeur stockés dans un coffre-fort ou une armoire contre l'humidité ambiante, principale cause de rouille, de corrosion et de moisissures. Il fonctionne sans électricité : un indicateur circulaire change de couleur selon son état — bleu quand il est sec et prêt à l'emploi, rose/violet lorsqu'il a atteint sa capacité d'absorption (entre 25 et 35% de son propre poids). Une fois saturé, il suffit de le passer au micro-ondes (environ 6 minutes, 600W) pour le régénérer et le réutiliser indéfiniment.",
    specs: {
      Fonctionnement: "absorption passive de l'humidité, sans alimentation électrique",
      "Indicateur de saturation":
        "témoin circulaire : bleu = sec/prêt à l'emploi, rose/violet = saturé",
      "Capacité d'absorption": "25 à 35% de son poids avant saturation",
      Régénération: "réutilisable, séchage au micro-ondes (600W, environ 6 minutes)",
      "Usage recommandé": "coffres-forts, armoires fortes, armoires à fusils",
    },
    images: [
      "/TSDSH/TSDSH 2.png",
      "/TSDSH/TSDSH 4.png",
      "/TSDSH/TSDSH 3.png",
      "/TSDSH/TSDSH 5.png",
      "/TSDSH/TSDSH 8.png",
      "/TSDSH/TSDSH 6.png",
      "/TSDSH/TSDSH 7.png",
      "/TSDSH/TSDSH 1.png",
    ],
    revendeurs: [
      {
        name: "1001coffres.com",
        prix: 23,
        url: "https://1001coffres.com/accessoires/8330-deshumidificateur-reutilisable-tresorsafe-pour-coffres-forts-et-armoires-fortes-.html",
      },
    ],
  },
];
